import template from './productBox.html';

let component = {
	template,
	bindings: {
		product:'=',
		parent:'=',
		modal:'<',
		page:'@'
	},
	controller: function(
		$scope,
		$rootScope, 
		Http, 
		Product, 
		$filter,
		$state,
		$ionicHistory,
		$ionicActionSheet,
		$ionicModal,
		growl,
		Compare,
		Customer,
		Basket
	) {
		"ngInject";

		const vm = this;
		const moreButtons = [
			{
				text: $filter('ucfirst')($filter('translate')('buy')),
				// callback: () => Basket.add(vm.product.id).then(() => {
				// 	$state.go('tab.checkout-cart')
				// })
				callback: () => {
					if(!Customer.session()) {
						Customer.create().then(function() {
							growl.info($filter('translate')('growl_automatic_customer_session_created'));
							addProduct();
						});
					} else {
						addProduct();
					}
				}
			}
		];

		vm.days = '0';

		var addProduct = function() {
			Basket.add(vm.product.id).then(function() {
				growl.success($filter('translate')('growl_basket_product_added'));
				return Product.get(vm.product.id, {
					include: 'accessories,services'
				}).then(function(res) {
					if ((res.accessories && res.accessories.length > 0) || (res.services && res.services.length > 0)) {
						$scope.product = res;
						$scope.modal = $ionicModal.fromTemplate('<upsell modal="modal" product="product"></upsell>', {
							scope: $scope,
							animation: 'slide-in-up'
						});
						$scope.modal.show();
					}
				});
			}).catch(function(err) {
				console.log(err);
			}).finally(() => {
			
			});
		}

		vm.togglePreferred = function(reason) {	
			Http.post('/v1/product/preferred', false, {
				uid: vm.product.id,
				reason: reason
			}).then(function(res) {
				if (reason !== vm.product.preferred) {
					vm.product.preferred = reason;
				} else {
					vm.product.preferred = null;
				}
			});
		}

		if (vm.product.icecat) {
			moreButtons.push({
				text: $filter('ucfirst')($filter('translate')('compare')),
				callback: () => Compare.add(vm.product)
			})
		}

		vm.more = ($event) => {
			$ionicActionSheet.show({
				buttons: moreButtons,
				titleText: '',
				cancelText: 'Cancel',
				cancel: function() {
					// add cancel code..
				},
				buttonClicked: function(index) {
					moreButtons[index].callback();
					return true;
				}
			});

		}

		vm.toProduct = function() {
			$ionicHistory.nextViewOptions({
				disableAnimate: true,
			});
			$state.go('tab.product', {
				uid: vm.product.id,
				ref: vm.page
			})
		}
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/productBox/productBox.component.js